// removed by extract-text-webpack-plugin
module.exports = {"customers-export":"_3ms-40Q5n _6rexmpxuB"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/customers-export/customers-export.css
 ** module id = 2092
 ** module chunks = 0
 **/